import { memo, ReactNode, useMemo } from 'react'

import './index.scss'
import Icon from '../Icon'
import { useBounds } from '../../hooks/useBounds'

type Option = {
  label: string | ReactNode
  icon?: string
  onClick: () => void
  onKeyDown?: (e: Event) => void
}

type DropdownSelection = {
  options: Option[]
  boundsRef?: any
}

const DropDownSelection = memo(({ options, boundsRef }: DropdownSelection) => {
  const { bounds } = useBounds(boundsRef)
  
  const styles = useMemo(() => {
    const styleObj = {}
    if (bounds) {
      if (typeof bounds?.width === 'string') styleObj.width = bounds.width
      else styleObj.width = `${bounds?.width}px`

      if (bounds.top) styleObj.top = bounds.top + bounds.height + 1
    }
    return styleObj
  }, [bounds])

  return (
    <div className="DropdownSelection" style={styles}>
      {options.map((option) => {
        const { label, icon, onClick, onKeyDown } = option
        return (
          <div
            className="DropdownSelection__option"
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={onKeyDown}
          >
            {icon && (<Icon icon={icon} />)}
            {label}
          </div>
        )
      })}
    </div>
  )
})

export default DropDownSelection
